const STYLES = {
  high: "bg-rose-50 text-rose-700 border border-rose-200",
  medium: "bg-amber-50 text-amber-700 border border-amber-200",
  low: "bg-sage-400/20 text-sage-600 border border-sage-400",
  open: "bg-amber-50 text-amber-700 border border-amber-200",
  in_progress: "bg-sky-50 text-sky-700 border border-sky-200",
  ready_for_review: "bg-violet-50 text-violet-700 border border-violet-200",
  published: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  needs_update: "bg-rose-50 text-rose-700 border border-rose-200",
  planned: "bg-ivory-100 text-navy-900 border border-border",
  new: "bg-ivory-100 text-navy-900 border border-border",
  in_brief: "bg-sky-50 text-sky-700 border border-sky-200",
  to_contact: "bg-amber-50 text-amber-700 border border-amber-200",
  contacted: "bg-sky-50 text-sky-700 border border-sky-200",
  closed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
};

export default function StatusBadge({ status }) {
  const cls = STYLES[status] || "bg-ivory-100 text-navy-900 border border-border";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium uppercase tracking-wider rounded-sm ${cls}`} data-testid={`status-${status}`}>
      {String(status).replace(/_/g, " ")}
    </span>
  );
}
